import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminTreatmentListItem, AdminTreatmentStatus, OperationType } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentListItem = asBuilder((): AdminTreatmentListItem => {
  return {
    id: faker.number.int(),
    treatmentCategories: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.lorem.word(),
    })),
    treatmentGroups: faker.helpers.multiple(() => ({
      id: faker.number.int(),
      name: faker.lorem.word(),
    })),
    names: faker.helpers.multiple(() => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    })),
    type: faker.helpers.enumValue(OperationType),
    status: faker.helpers.enumValue(AdminTreatmentStatus),
  }
})
